// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1gFzq","rootSmall":"AddTileButton_rootSmall__x3rFU"};